export default {
  topNav: {
    cadLabel: 'CAD Software',
    fbjLabel: 'Cutting Machine (1652 Series)',
    cqjLabel: 'Cutting Machine (1506 Series)'
  },

  w1: {
    label1: 'Easy to learn',
    label2: 'More with less',
    label3: 'One-stop service'
  },

  clientArea: {
    sectionTitle: 'Your trust is our biggest support'
  },

  softwareFeature: {
    subTitleLeft: 'Replace Handwork, Save time and effort',
    titleLeft: 'Draw and grading right away',
    introLeft: 'Easily creating various shoe kinds such as sneakers, kids shoes, dad shoes ..etc; And with just one click, you can perfectly grading to any size you like;',
    btnLeft: 'Discover more!',
    subTitleRight: 'Simple it is!',
    titleRight: 'Flexible pattern design',
    introRight: 'With numerious shortcuts, thoughtful and powerful features, SXY frees you from tedious work flow, turning two steps into one and just cut to the chase! Also saves you lots of energy, and have you stayed focused on creating incredible shoe designs;',
    btnRight: 'Start your free trial',
  },

  machineFeature: {
    subTitleLeft: 'In hot sales!',
    titleLeft: 'BRAND NEW PRODUCT: FC-1653',
    list: ['Selling over 100+ regions','Perfectly fit with SXY','One-stop after-sales service'],
    subTitleRight: 'Exclusive tool for designers',
    titleRight: 'Fast to cut, efficient to grading',
    introRight: 'After using SXY to design your desired shoe patterns, you can then immediately cut it out on our cutting plotter; With high accuracy and fast movement, it dramatically reduce tons of designers work load;',
    btnRight: 'NEW YEAR SPECIAL!',
    tableLabel: ['Model','Area','Depth','Transfer','Material'],
    machineType: 'FC-1653C，FC-1653CA，FC-1653SE',
    cuttingArea: '923*618mm',
    cuttingDepth: '≤2mm',
    dataTransfer: 'Ethernet，Parallel',
    cuttingMaterial: 'Cardboard，Plastic board，Kraft paper，PVC'
  },

  news: {
    sectionLabel: 'Recent News',
    btnPd: 'Publish',
    btnRm: 'Read More'
  },

  about: {
    companyName: 'Simple Technology - Shenpusoft.',
    companyDesp: 'We are dedicated in development and application of Shoe Pattern Design CAD Software and NC Cutting Equipment',
    companyIntroL1: 'Wenzhou Simple Technology Inc. is founded in 2002; we are a high-tech company that develop, deliver and service CAD/CAM software and hardware equipment;',
    companyIntroL2: 'After years of servicing and immersing ourselves in the shoes industry, we have continuously learned and summarized all kinds of designers handwork skills, and apply it onto our products, bringing our clients a better and effective automation solution!'
  },

  contact: {
    sectionLabel: 'Contact Us',
    location: 'Unit 221, Jibangguoji Building, Lucheng District, Wenzhou, Zhejiang, China',
    emailLabel: 'Email',
    callLabel1: 'Customer Service',
    callLabel2: 'Sales Service',
    friendLabel: 'Links',
    wechatLabel: 'Add our customer service wechat so we can help you better!'
  }
}